export const Asterisks = () => (
    <span className="text-danger" style={{fontSize: "18px"}} aria-hidden="true">*</span>
)
